import axios from "axios";

const generateReportBase = async (apiURL, sessionId, sessionLapIdx, referenceId, referenceLapIdx) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("No se encontró un token");
  }
  const requestBody = {
    session_id: sessionId,
    session_lap_idx: sessionLapIdx,
    reference_id: referenceId,
    reference_lap_idx: referenceLapIdx,
  };
  console.log(requestBody);
  try {
    const response = await axios.post(apiURL, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    // Extract the file name and base64-encoded content
    const { filename, report } = response.data;

    // Decode the base64 content into a blob
    const byteCharacters = atob(report);
    const byteNumbers = Array.from(byteCharacters).map((char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    // Change the browser tab title
    document.title = filename;

    // Create a URL for downloading the file
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();

    document.title = "Hermes Motorsport";
  } catch (error) {
    console.error("Error en la solicitud:", error);
    throw error;
  }
};

export const generateReport = async (sessionId, sessionLapIdx, referenceId, referenceLapIdx) => {
  const apiURL = `${process.env.REACT_APP_API}generate-report`;
  await generateReportBase(apiURL, sessionId, sessionLapIdx, referenceId, referenceLapIdx);
};

export const generateLatestReport = async (sessionId, sessionLapIdx, referenceId, referenceLapIdx) => {
  const apiURL = `${process.env.REACT_APP_API}generate-latest-report`;
  await generateReportBase(apiURL, sessionId, sessionLapIdx, referenceId, referenceLapIdx);
};
